module.exports = __webpack_public_path__ + "img/Shower.20b9d679.png";